import React, { useEffect, useState } from 'react';
import './App.css';
import InventoryTable from './components/InventoryTable';
import { loadInventoryData } from './services/inventoryService';
import { InventoryData } from './types/inventory';

function App() {
  const [inventoryData, setInventoryData] = useState<InventoryData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await loadInventoryData();
        setInventoryData(data);
      } catch (err) {
        setError('Failed to load inventory data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="App">
      <main className="App-main">
        {loading && <div className="loading">Loading inventory data...</div>}
        {error && <div className="error">{error}</div>}
        {inventoryData && <InventoryTable data={inventoryData} />}
      </main>
    </div>
  );
}

export default App;
